<div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <span class="ui grey">Home</span>
        <h2
          class="ui primary header"
          style="display: flex; align-items: center"
        >
          Chat with NCC
        </h2>
      </div>
    </div>
  </div>

  <div class="ui divider" *ngIf="!fullScreenMode"></div>

  <div fxLayout="row">
    <app-all-conversations></app-all-conversations>
    <div style="width: 100%; padding-top: 30px">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
